import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';

/**
 * Go-live checklist. The three things to do before taking real money. This is
 * the ONLY place KYC appears, and it is never forced. Reused on the success
 * screen and on the dashboard (until the merchant is Live).
 *
 * @param {{ goLiveStatus?: string }} props - 'not_started'|'kyc_pending'|'wallet_added'|'live'
 */
const GoLiveChecklist = ({ goLiveStatus = 'not_started' }) => {
  const navigate = useNavigate();

  const items = [
    {
      key: 'kyc',
      label: 'Verify your business',
      done: ['wallet_added', 'live'].includes(goLiveStatus),
    },
    {
      key: 'wallet',
      label: 'Add a payout wallet',
      done: ['wallet_added', 'live'].includes(goLiveStatus),
    },
    {
      key: 'live',
      label: 'Switch to Live and integrate',
      done: goLiveStatus === 'live',
    },
  ];

  return (
    <ul className="golive-list">
      {items.map((item) => (
        <li key={item.key} className={`golive-item ${item.done ? 'done' : ''}`}>
          <span className="golive-marker" aria-hidden="true">
            {item.done && <Check size={14} strokeWidth={3} />}
          </span>
          <span className="golive-label">{item.label}</span>
          {!item.done && (
            <button
              type="button"
              className="golive-action"
              onClick={() => navigate('/dashboard/settings')}
            >
              Start
            </button>
          )}
        </li>
      ))}
    </ul>
  );
};

export default GoLiveChecklist;
